import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Product",
  computed: {
    shoppingCardInfo: function shoppingCardInfo() {
      var _this = this;

      var counter = 0;
      this.shoppingCard.forEach(function (item) {
        if (item.id === _this.product.id) {
          counter++;
        }
      });
      return counter;
    }
  },
  methods: {
    selectProduct: function selectProduct() {
      if (!this.product.available) {
        this.$vs.notify({
          text: "محصول مورد نظر موجود نمیباشد.",
          color: "warning",
          position: "bottom-center"
        });
        return;
      }

      this.$emit("select");
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    shoppingCard: {
      type: Array,
      required: true
    }
  }
};